import { toast } from 'react-toastify';

export const toaster = (title, type) => {

  const options = {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  };

  if(!type || type === "") type = "info";

  switch(type){
    case "success":
      toast.success(title, options);
      break;
    case "warning":
      toast.warning(title, options);
      break;
    case "error":
      toast.error(title, options);
      break;
    case "info":
    default:
      toast.info(title, options);
      break;
  }
  
}
